import React, { Component } from "react";
import Header from "../../Content/Header/Header";
import { Redirect } from "react-router-dom";
import { checkCookie } from "../../Utils/Utils";
import { Card } from "react-bootstrap";
require("./booth.scss");

class EthnicElegance extends Component {
  componentDidMount() {
    if (!checkCookie("emailId")) {
      this.setState({ redirect: true });
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      redirect: false
    };
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
    return (
      <div className="booth-container">
        <Header />
        <div className="booth-title">Ethnic Elegance</div>
        <Card.Img className="booth-image" src="/ethnic-wear.jpg" />
        <Card.Text className="booth-description">
          Step into a world of elegance and charm. Discover exquisite flowing
          chiffon saris, stunning sari blouses, kurtas, dazzling fashion jewelry
        </Card.Text>
      </div>
    );
  }
}

export default EthnicElegance;
